import { logError } from "@utils/sentry-error";
import { shortcodeHelper } from "shortcode-helper";
import { renderComponent } from "../common";

export function importComponent(shortcode: string, elements: Element[]): void {
	shortcodeHelper(shortcode)
		.then((module) => {
			renderComponent(shortcode, module?.default, elements, {});
		})
		.catch((error) => {
			logError(error);
		});
}
